import { Box } from "@mui/material"

export default function Section({ children }: { children: JSX.Element }) {
  return (
    <Box sx={{ maxWidth: "100%", width: "100%", m: 2 }}>
      <Box sx={{ p: 2 }}>{children}</Box>
    </Box>
  )
}
